"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Label = _interopRequireDefault(require("../Label"));
var _Stack = _interopRequireDefault(require("../Stack"));
var _createStyles = require("../styles/createStyles");
const useStyles = (0, _createStyles.createStyles)(_ref => {
  let {
    theme
  } = _ref;
  const {
    transitions,
    busbud
  } = theme;
  const {
    colors,
    spacing,
    styles
  } = busbud;
  return {
    barWrapper: {
      '& span': {
        width: spacing(10)
      },
      textAlign: 'center',
      '&:not(:last-child)': {
        marginRight: spacing(2)
      }
    },
    barBackground: {
      height: spacing(32),
      position: 'relative',
      backgroundColor: colors.component.barChart.backColumn.default.background,
      borderRadius: styles.rounding.lg
    },
    barBackgroundNeutral: {
      height: spacing(32),
      position: 'relative',
      backgroundColor: colors.component.barChart.backColumn.neutral.background,
      borderRadius: styles.rounding.lg
    },
    bar: {
      position: 'absolute',
      bottom: 0,
      backgroundColor: colors.component.barChart.frontColumn.default.background,
      borderRadius: styles.rounding.lg,
      width: '100%',
      boxShadow: styles.shadow.subtle.lg,
      transition: transitions.create('', {
        duration: transitions.duration.shortest,
        easing: transitions.easing.easeInOut
      })
    }
  };
});

/**
 * **❗️ DEPRECATED**: Use the `BarChartColumn` from pubweb instead.
 */
const BarChartColumn = function BarChartColumn(props) {
  const {
    data: {
      label,
      value
    },
    noDataLabelText = 'Unknown',
    formatter,
    classes: classesOverrides,
    maxValue
  } = props;
  const {
    classes
  } = useStyles({
    classesOverrides
  });
  let parsedValue;
  let barBackgroundClass;
  if (value !== null) {
    parsedValue = formatter?.(value) ?? value;
    barBackgroundClass = classes.barBackground;
  } else {
    parsedValue = noDataLabelText;
    barBackgroundClass = classes.barBackgroundNeutral;
  }
  return /*#__PURE__*/_react.default.createElement(_Stack.default, {
    direction: "column",
    className: classes.barWrapper,
    spacing: 2
  }, /*#__PURE__*/_react.default.createElement(_Label.default, {
    size: "lg",
    fontWeight: "heavy",
    color: "text.tertiary.opaque"
  }, label), /*#__PURE__*/_react.default.createElement("div", {
    className: barBackgroundClass
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.bar,
    style: {
      height: value ? `${value / maxValue * 100}%` : 0
    }
  })), /*#__PURE__*/_react.default.createElement(_Label.default, {
    size: "lg",
    fontWeight: "heavy",
    color: "text.tertiary.opaque",
    noWrap: true
  }, parsedValue));
};
var _default = exports.default = BarChartColumn;